import { OrganizationStoreService } from "../../organizations/services/organization.store.service";
import { ProfileService } from "../../users/services/profile.service";
import { ProfileStore } from "../services/profile.storage.service";

import { MatomoResolver } from "./matomo.resolver";

export function availableTrainsResolverFactory(pageName: string, pageCategory: string) {
  return (profileService: ProfileService, profileStore: ProfileStore, organizationStoreService: OrganizationStoreService) => 
    new MatomoResolver(profileStore, profileService, pageName, pageCategory, organizationStoreService);
}